import Vue from 'vue';
import VueMenu from './menu-plugin';

export default ({ app }) => {
    Vue.use(VueMenu, app.router);
};
